import * as React from 'react';

import { cn } from '@/utils/cn';

export const PageTitle = React.forwardRef<HTMLHeadingElement, React.HTMLAttributes<HTMLHeadingElement>>(
    ({ className, ...props }, ref) => (
        <h1 ref={ref} className={cn('font-heading text-cocoa-1000 text-3xl font-medium', className)} {...props} />
    ),
);
PageTitle.displayName = 'PageTitle';
